export const commonEnvironment = {
    default_locale: 'en',
    locale_api_url: 'https://geoip-db.com/json/',
    client_id: '32B502C4-FA0C-4549-95BC-E131D8BD1888',
    enable_notifications: true,
    notification_limit:500,
    sms_notification_from: '0261905833'
};



// WEBPACK FOOTER //
// ./src/environments/environment.common.ts